import {EntityData, field} from "@fedeltapointofsale/data-client";

export class SupplierInvoiceData extends EntityData<SupplierInvoiceData> {
    @field invoiceId: number;

}
